import { useContext } from 'react';
import { CheckoutContext } from '@/context/CheckoutContext';
import { useSelectedPaymentMethod } from '@/hooks/useSelectedPaymentMethod';
import { useTranslate } from '@/hooks/useTranslate';
import { getCustomerCountry } from '@/utils/customer';
import { IOF_DISCLAIMER_PT_KEY, shouldShowIOFDisclaimer } from '@/utils/IOFDisclaimer';

/**
 * Brazil IOF tax line under the pay button (ACDEV-29689). Returns null outside
 * Brazil and for Stripe Pix. The sentence is always Portuguese, on every locale.
 */
export const IOFDisclaimer = () => {
  const { customer, paymentMethodsSettings } = useContext(CheckoutContext);
  const { selectedPaymentMethod } = useSelectedPaymentMethod();
  const { t } = useTranslate();
  const provider = paymentMethodsSettings.find(
    (method) => method.paymentMethodName === selectedPaymentMethod
  )?.provider;

  if (!shouldShowIOFDisclaimer(getCustomerCountry(customer), selectedPaymentMethod, provider)) {
    return null;
  }

  return (
    <div
      data-testid="iof-disclaimer"
      className="w-full text-center text-[10px] font-normal leading-[140%] text-muted-foreground"
    >
      {t(IOF_DISCLAIMER_PT_KEY)}
    </div>
  );
};
